import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthBusiness } from '../../contexts/AuthBusinessContext';

/**
 * RouteHistoryTracker
 * 
 * Kullanıcının gezindiği operasyonel sayfaları (Masa Servisi, Sipariş Takip, Mutfak vb.)
 * otomatik olarak localStorage'a kaydeder.
 * 
 * Uygulama alta atılıp tekrar açıldığında veya PWA yeniden başlatıldığında,
 * kullanıcının kaldığı ekrandan devam etmesini sağlar.
 */
export const RouteHistoryTracker = () => {
  const location = useLocation();
  const { isAuthenticated, selectedBusiness } = useAuthBusiness();

  useEffect(() => {
    if (!isAuthenticated) return;

    const path = location.pathname;

    // Kaydedilmeyecek rotalar (Login, Register, Landing, Geçiş ekranları)
    const ignoredPaths = [
      '/',
      '/login',
      '/register',
      '/brands',
      '/unauthorized',
      '/privacy',
      '/terms',
      '/auth/callback'
    ];

    // Public QR menü ve otel sayfaları da dashboard restore'a dahil edilmez
    const isIgnored = ignoredPaths.includes(path) || 
                      path.startsWith('/qr/') || 
                      path.startsWith('/menu/') || 
                      path.startsWith('/hotel/');

    // 🛡️ GLOBAL SCROLL KURTARICI:
    // Modal, dialog veya sayfa bazlı kilitlerden kalan document.body / html inline overflow stillerini temizle
    if (typeof document !== 'undefined') {
      if (document.body.style.overflow === 'hidden') {
        document.body.style.overflow = '';
      }
      if (document.documentElement.style.overflow === 'hidden') {
        document.documentElement.style.overflow = '';
      }
    }

    if (!isIgnored) {
      const routeData = {
        path: path + location.search,
        businessId: selectedBusiness?.id || localStorage.getItem('selectedBusinessId') || '',
        timestamp: Date.now()
      };

      try {
        localStorage.setItem('sectorpilot_last_route', JSON.stringify(routeData));
      } catch (e) {
        // Storage full or private mode
      }
    }
  }, [location.pathname, location.search, isAuthenticated, selectedBusiness?.id]);

  return null;
};

/**
 * getLastVisitedRoute
 * Son 12 saat içinde kaydedilmiş ve geçerli bir rota varsa döndürür.
 */
export const getLastVisitedRoute = (currentBusinessId) => {
  try {
    const raw = localStorage.getItem('sectorpilot_last_route');
    if (!raw) return null;

    const { path, businessId, timestamp } = JSON.parse(raw);

    // 12 saatten eski kayıtları geçersiz say (uzun süre sonra açıldıysa taze dashboard görsün)
    const MAX_AGE = 12 * 60 * 60 * 1000; // 12 saat
    if (Date.now() - timestamp > MAX_AGE) {
      localStorage.removeItem('sectorpilot_last_route');
      return null;
    }

    // Eğer farklı bir işletmeye geçildiyse eski işletmenin alt sayfasını açma
    if (currentBusinessId && businessId && currentBusinessId !== businessId) {
      return null;
    }

    // Geçerli bir operasyonel rota mı?
    if (path && typeof path === 'string' && path.startsWith('/')) {
      return path;
    }
  } catch (e) {
    localStorage.removeItem('sectorpilot_last_route');
  }
  return null;
};

export default RouteHistoryTracker;
